import { config as defaultConfig } from '@tamagui/config/v3';
import { createTamagui, createTokens } from 'tamagui';

// Traffic Light 4x Custom Tokens
const tokens = createTokens({
  ...defaultConfig.tokens,
  color: {
    ...defaultConfig.tokens.color,
    // Traffic light colors
    trafficRed: '#dc2626',
    trafficOrange: '#ea580c',   // Tailwind orange-600
    trafficYellow: '#eab308',
    trafficGreen: '#22c55e',
    // Theme colors
    background: '#121212',
    foreground: '#fafafa',
    card: '#1c1c1c',
    cardForeground: '#fafafa',
    primary: '#22c55e',
    primaryForeground: '#ffffff',
    secondary: '#00ffff',
    secondaryForeground: '#1a1a1a',
    muted: '#262626',
    mutedForeground: '#c5c5c5',
    accent: '#00bfbf',
    accentForeground: '#ffffff',
    border: '#262626',
  },
  radius: {
    ...defaultConfig.tokens.radius,
    0: 0,
    1: 2,
    2: 4,
    3: 6,
    4: 8,
    true: 6,
  },
});

const appConfig = createTamagui({
  ...defaultConfig,
  tokens,
  themes: {
    dark: {
      background: tokens.color.background,
      backgroundHover: tokens.color.muted,
      backgroundPress: tokens.color.muted,
      backgroundFocus: tokens.color.muted,
      color: tokens.color.foreground,
      colorHover: tokens.color.foreground,
      colorPress: tokens.color.foreground,
      colorFocus: tokens.color.foreground,
      borderColor: tokens.color.border,
      borderColorHover: tokens.color.primary,
      borderColorPress: tokens.color.primary,
      borderColorFocus: tokens.color.primary,
      shadowColor: 'rgba(0,0,0,0.5)',
      shadowColorHover: 'rgba(0,0,0,0.7)',
    },
  },
  defaultTheme: 'dark',
});

export type Conf = typeof appConfig;

declare module 'tamagui' {
  interface TamaguiCustomConfig extends Conf {}
}

export default appConfig;
